import * as StateLib from "@/Utils/StateLib";
import React, { Fragment } from "react";
import { ToolIcon } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const UndoRedoComposite = props => {
  let wsMgr = StateLib.GetWSMgr();
  let doc = StateLib.GetDoc();
  const inBackgroundEditMode = Globals._uiConfig.InBackgroundEditorMode();
  const ReCalcHolderNodes = () => {
    if (doc && doc.IsCustomChart() && doc.IsPositionDocument()) {
      const sc = wsMgr.GetSubChartMgr().GetCurrentSubChart().GetSubChartID();
      doc.HandlePositionsGroup(sc);
      wsMgr.ReloadCurrentSubChart();
    }
  };
  const Undo = () => {
    wsMgr.UndoLastTransaction();
    ReCalcHolderNodes();
    StateLib.ReRenderCanvas();
  };
  const Redo = () => {
    wsMgr.RedoLastTransaction();
    ReCalcHolderNodes();
    StateLib.ReRenderCanvas();
  };
  return (
    <Fragment>
      <ToolIcon
        name={"rotate-left"}
        title={"Undo"}
        onClick={Undo}
        disabled={!(doc && doc.UndoBufferLength() > 0)}
        tooltipProps={{ message: appstr("Undo") }}
        id={"undo-change-btn"}
        dataTestId={
          inBackgroundEditMode ? "background-editor-toolbar-undo-btn" : editModeTestId("undo-btn")
        }
      />
      <ToolIcon
        name={"rotate-right"}
        title={"Redo"}
        onClick={Redo}
        disabled={!(doc && doc.RedoBufferLength() > 0)}
        tooltipProps={{ message: appstr("Redo") }}
        id={"redo-change-btn"}
        dataTestId={
          inBackgroundEditMode ? "background-editor-toolbar-redo-btn" : editModeTestId("redo-btn")
        }
      />
    </Fragment>
  );
};

export default UndoRedoComposite;
